import React from "react";
import Requisition from "../../requisition/Requisition";
import { AuthContext } from "../../../util/context";
import { useContext } from "react";
import Login from "../../auth/Login";
import Dashboard from "../../dashboard/Dashboard";

export default function RequisitionPage() {
  let view;
  const { isAuthenticated, user } = useContext(AuthContext);

  const viewRequisition =
    user?.job_role?.toLowerCase() === "accountant" ||
    user?.job_role?.toLowerCase() === "lawyer" ||
    user?.job_role?.toLowerCase() === "lawyer" ||
    user?.job_role?.toLowerCase() === "lawyer" ||
    user?.job_role?.toLowerCase() === "hop" ||
    user?.job_role?.toLowerCase().includes("hod") ||
    user?.job_role?.toLowerCase() === "seed";

  if (viewRequisition) {
    view = <Requisition />;
  } else {
    view = <Dashboard />;
  }
  return <>{isAuthenticated ? view : <Login />}</>;
}
